import { IBaseOption } from '~/utils/interface/common';
import { StatusJobEnum } from '../enum/common';

export const mockJobsList = {
  responses: [
    {
      id: '1',
      name: 'Pipe Installation - Kitchen',
      client: {
        id: '13',
        firstName: 'Daniel',
        lastName: 'Pham',
        email: 'daniel.pham@example.com',
        phoneNumber: '(555) 987-6543',
        address: '567 Maple Avenue',
        address2: 'Unit 12B',
        city: 'Seattle',
        state: 'WA',
        zipCode: '98101',
        country: 'USA',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1739145087174_blob',
      },
      type: 'Gas',
      tags: 'RN (Residential New)',
      source: 'Website',
    },
    {
      id: '2',
      name: 'Leak Repair - Bathroom',
      client: {
        id: '12',
        firstName: 'Michael',
        lastName: 'Nguyen',
        email: 'michael.nguyen@example.com',
        phoneNumber: '(980) 699-9806',
        address: '102 Pine Avenue',
        address2: 'Suite 5C',
        city: 'San Francisco',
        state: 'CA',
        zipCode: '94107',
        country: 'USA',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1739473682712_images.jpg',
      },
      type: 'Water heater',
      tags: 'CR (Commercial Return)',
      source: 'Google',
    },
    {
      id: '3',
      name: 'Water Heater Maintenance',
      client: {
        id: '11',
        firstName: 'Mary',
        lastName: 'Jones',
        email: 'williamm.garcia@yahoo.com',
        phoneNumber: '(342) 423-4234',
        address: '8367 Pine St',
        address2: '',
        city: 'New York',
        state: 'NC',
        zipCode: '60641',
        country: 'United States',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1737856862444_blob',
      },
      type: 'Mainline backup',
      tags: 'CN (Commercial New)',
      source: 'Billboard',
    },
    {
      id: '4',
      name: 'Drain Inspection - Basement',
      client: {
        id: '8',
        firstName: 'William',
        lastName: 'Garcia',
        email: 'mary.jones@yahoo.com',
        phoneNumber: '',
        address: '5951 Washington St',
        address2: 'Suite 355',
        city: 'New York',
        state: 'IL',
        zipCode: '78994',
        country: 'United States',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1738655290721_blob',
      },
      type: 'Secondary line backup',
      tags: 'RR (Residential Return)',
      source: 'Yellow pages',
    },
    {
      id: '5',
      name: 'Sink Installation - Office',
      client: {
        id: '7',
        firstName: 'Robert',
        lastName: 'Williams',
        email: 'william.garcia@yahoo.com',
        phoneNumber: '',
        address: '7355 Washington St',
        address2: 'Apt 424',
        city: 'New York',
        state: 'PA',
        zipCode: '86816',
        country: 'United States',
      },
      type: 'Leak',
      tags: 'CR (Commercial Return)',
      source: 'Website',
    },
    {
      id: '6',
      name: 'Toilet Repair - Residential',
      client: {
        id: '5',
        firstName: 'Michael',
        lastName: 'Cardic',
        email: 'michaelcardic@gmail.com',
        phoneNumber: '(043) 443-7643',
        address: '2080 Curtner Ave, San Jose, CA 95124, USA',
        address2: '',
        city: 'San Jose',
        state: 'California',
        zipCode: '95124',
        country: 'USA',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1738146509029_download.jpg',
      },
      type: 'Remodel or addition',
      tags: 'CN (Commercial New)',
      source: 'Google',
    },
    {
      id: '7',
      name: 'Pipeline Maintenance - Industrial',
      client: {
        id: '3',
        firstName: 'John',
        lastName: 'Michael',
        email: 'michael@gmail.com',
        phoneNumber: '(989) 865-6865',
        address: '2080 Curtner Ave, San Jose, CA 95124, USA',
        address2: '',
        city: 'San Jose',
        state: 'California',
        zipCode: '95124',
        country: 'USA',
      },
      type: 'Fixtures repair (toilet, faucet)',
      tags: 'RR (Residential Return)',
      source: 'Billboard',
    },
    {
      id: '8',
      name: 'Sewer Line Inspection',
      client: {
        id: '8',
        firstName: 'William',
        lastName: 'Garcia',
        email: 'mary.jones@yahoo.com',
        phoneNumber: '',
        address: '5951 Washington St',
        address2: 'Suite 355',
        city: 'New York',
        state: 'IL',
        zipCode: '78994',
        country: 'United States',
        avatarImage: 'https://noble-plumbing-dev.s3.amazonaws.com/1738655290721_blob',
      },
      type: 'Slab leak',
      tags: 'RN (Residential New)',
      source: 'Yellow pages',
    },
  ],
  pagination: {
    page: '1',
    limit: '10',
    totalItems: 8,
    totalPages: 1,
  },
};

export const mockDataJobType: IBaseOption[] = [
  { label: 'Gas', value: 'GAS' },
  { label: 'Water Heater', value: 'WATER_HEATER' },
  { label: 'Mainline Backup', value: 'MAINLINE_BACKUP' },
  { label: 'Secondary Line Backup', value: 'SECONDARY_LINE_BACKUP' },
  { label: 'Leak', value: 'LEAK' },
  { label: 'Remodel or Addition', value: 'REMODEL_OR_ADDITION' },
  { label: 'Fixture Repair (Toilet, faucet)', value: 'FIXTURE_REPAIR' },
  { label: 'Slab Leak', value: 'SLAB_LEAK' },
  { label: 'Other', value: 'OTHER' },
];

export const mockDateDiscountJob: IBaseOption[] = [
  { label: 'Percentage (%)', value: 'PERCENTAGE' },
  { label: 'Dollar ($)', value: 'DOLLAR' },
];

export const mockDateTypeChecklistJob: IBaseOption[] = [
  { label: 'Checkbox', value: 'CHECKBOX' },
  { label: 'Text', value: 'TEXT' },
  { label: 'Pass/Flag/Fail', value: 'PASS_FLAG_FAIL' },
];

export const mockDataUnitJob: IBaseOption[] = [
  { label: 'Plumbing', value: 'PLUMBING' },
  { label: 'HVAC', value: 'HVAC' },
];

export const mockDataJobTag: IBaseOption[] = [
  { label: 'Residential New', value: 'RESIDENTIAL_NEW' },
  { label: 'Residential Repeat', value: 'RESIDENTIAL_REPEAT' },
  { label: 'Commercial New', value: 'COMMERCIAL_NEW' },
  { label: 'Commercial Repeat', value: 'COMMERCIAL_REPEAT' },
];

export const mockDataJobSource: IBaseOption[] = [
  { label: 'Google', value: 'GOOGLE' },
  { label: 'Billboard', value: 'BILLBOARD' },
  { label: 'Yellow Pages', value: 'YELLOW_PAGES' },
  { label: 'Website', value: 'WEBSITE' },
  { label: 'Referral', value: 'REFERRAL' },
];

export const mockDataStatusJob: IBaseOption[] = [
  {
    label: 'Not Started',
    value: StatusJobEnum.NOT_STARTED,
  },
  {
    label: 'In Progress',
    value: StatusJobEnum.IN_PROGRESS,
  },
  {
    label: 'Completed',
    value: StatusJobEnum.COMPLETED,
  },
  {
    label: 'Canceled',
    value: StatusJobEnum.CANCELED,
  },
  {
    label: 'No Go',
    value: StatusJobEnum.NO_GO,
  },
  {
    label: 'Recall',
    value: StatusJobEnum.RECALL,
  },
  {
    label: 'J.O.H',
    value: StatusJobEnum.J_O_H,
  },
  {
    label: 'J.I.P.',
    value: StatusJobEnum.J_I_P,
  },
];

export const optionFilterStatusJob: IBaseOption[] = [
  {
    label: 'All',
    value: StatusJobEnum.ALL,
  },
  {
    label: 'Not Started',
    value: StatusJobEnum.NOT_STARTED,
  },
  {
    label: 'In Progress',
    value: StatusJobEnum.IN_PROGRESS,
  },
  {
    label: 'Completed',
    value: StatusJobEnum.COMPLETED,
  },
  {
    label: 'Canceled',
    value: StatusJobEnum.CANCELED,
  },
  {
    label: 'No Go',
    value: StatusJobEnum.NO_GO,
  },
  {
    label: 'Recall',
    value: StatusJobEnum.RECALL,
  },
  {
    label: 'J.O.H',
    value: StatusJobEnum.J_O_H,
  },
  {
    label: 'J.I.P.',
    value: StatusJobEnum.J_I_P,
  },
];

export const optionFilterJobType: IBaseOption[] = [
  { label: 'All', value: 'ALL' },
  { label: 'Gas', value: 'GAS' },
  { label: 'Water Heater', value: 'WATER_HEATER' },
  { label: 'Mainline Backup', value: 'MAINLINE_BACKUP' },
  { label: 'Secondary Line Backup', value: 'SECONDARY_LINE_BACKUP' },
  { label: 'Leak', value: 'LEAK' },
  { label: 'Remodel or Addition', value: 'REMODEL_OR_ADDITION' },
  { label: 'Fixture Repair (Toilet, faucet)', value: 'FIXTURE_REPAIR' },
  { label: 'Slab Leak', value: 'SLAB_LEAK' },
  { label: 'Other', value: 'OTHER' },
];
